


import { NavBarAccessService } from '@/services/NavBarAccessService';
import { NavBarAccessModel, DocumentsToStore, Workflow } from '@/types';
import { Search } from '@/types/constants/routes/search';

export default {
  name: 'WelcomeRedirect',
  methods: {
    async checkPermissionToModule(this: any) {
      const welcomeModuleUrl = this.$route.params.module;
      if (!welcomeModuleUrl) {
        this.goToSearch();
        return;
      }

      let navBarAccessModel: NavBarAccessModel = {} as NavBarAccessModel;
      try {
        navBarAccessModel = await NavBarAccessService.getNavBarAccessAsync();
      } catch (error) {
        this.$log(error);
        this.goToSearch();
        return;
      }

      if (!navBarAccessModel) {
        this.goToSearch();
        return;
      }

      switch (welcomeModuleUrl.toLowerCase()) {
        case DocumentsToStore.Base.path.toLowerCase().removeLeadingSlash(): {
          if (navBarAccessModel.index) {
            this.$router.push(DocumentsToStore.Base.path);
            return;
          }
        }
        case Workflow.Base.path.toLowerCase().removeLeadingSlash(): {
          if (navBarAccessModel.workflow) {
            this.$router.push(Workflow.Base.path);
            return;
          }
        }
      }

      this.goToSearch();
    },
    goToSearch(this: any) {
      this.$router.push({ name: Search.Criteria.name });
    }
  },
  created(this: any) {
    this.checkPermissionToModule();
  }
};
